import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class InstructorService {
	constructor(private httpclientService: HttpclientService) {}

	loadInstructorList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/InstructorGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadPersonByStaffType(SchoolID, PersonTypeID, Active) {
		var postResult$ = new Subject();
		var url = "Report/PersonByStaffTypeSelect?SchoolID=" + SchoolID + "&PersonTypeID=" + PersonTypeID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
